import React from 'react';
import { motion } from 'framer-motion';

/**
 * Ambient, slow-moving red glow blobs that sit behind everything.
 * Purely decorative — pointer-events disabled, fixed to viewport.
 */
const AmbientGlow = () => {
  return (
    <div
      aria-hidden="true"
      className="fixed inset-0 -z-10 overflow-hidden pointer-events-none"
      data-testid="ambient-glow"
    >
      {/* Top-left ember */}
      <motion.div
        className="absolute -top-40 -left-40 w-[46rem] h-[46rem] rounded-full"
        style={{
          background:
            'radial-gradient(closest-side, rgba(239,91,91,0.32), rgba(239,91,91,0.10) 55%, transparent 78%)',
          filter: 'blur(60px)',
        }}
        animate={{
          x: [0, 90, -40, 0],
          y: [0, 60, 120, 0],
          scale: [1, 1.12, 0.95, 1],
        }}
        transition={{ duration: 26, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Bottom-right ember */}
      <motion.div
        className="absolute -bottom-52 -right-52 w-[52rem] h-[52rem] rounded-full"
        style={{
          background:
            'radial-gradient(closest-side, rgba(239,91,91,0.28), rgba(239,91,91,0.08) 55%, transparent 78%)',
          filter: 'blur(70px)',
        }}
        animate={{
          x: [0, -70, 40, 0],
          y: [0, -50, -110, 0],
          scale: [1, 1.08, 0.9, 1],
        }}
        transition={{ duration: 32, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Center drifting warmth */}
      <motion.div
        className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] rounded-full"
        style={{
          background:
            'radial-gradient(closest-side, rgba(239,91,91,0.18), rgba(239,91,91,0.05) 60%, transparent 82%)',
          filter: 'blur(80px)',
        }}
        animate={{
          x: [-40, 40, -20, -40],
          y: [-20, 30, 60, -20],
          opacity: [0.65, 0.95, 0.7, 0.65],
        }}
        transition={{ duration: 40, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>
  );
};

export default AmbientGlow;
